import {
  ApiTagTypes,
  Call,
  CallKind,
  RealCall,
  Scorecard,
  ScorecardResponse,
  SimulationCallWithApiListPracticeProspect,
} from '../../types';
import { parseProspect } from '../../utils';
import { apiSlice } from '../api.services';

type GetCallResponse = {
  data: {
    call: SimulationCallWithApiListPracticeProspect | RealCall;
  };
};

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCall: builder.query<Call, string>({
      query: (callSid) => ({
        url: `/calls/${callSid}`,
        method: 'GET',
      }),
      transformResponse: (response: GetCallResponse) => {
        // Parse the practice prospect if the call is a simulation.
        if (response.data.call.callKind === CallKind.SIMULATION) {
          return {
            ...response.data.call,
            practiceProspect: parseProspect(response.data.call.practiceProspect),
          };
        }
        return response.data.call;
      },
      providesTags: (_, __, callSid) => [{ type: ApiTagTypes.CALLS, id: callSid }],
    }),
    getCallScorecard: builder.query<Scorecard, string>({
      query: (callSid) => `/calls/${callSid}/scorecard`,
      transformResponse: (response: ScorecardResponse) => response.data.scorecard,
      providesTags: (_, __, callSid) => [{ type: ApiTagTypes.SCORECARDS, id: callSid }],
    }),
  }),
});

export const { useGetCallQuery, useGetCallScorecardQuery } = enhancedApiSlice;
